// Blueprint: forge/blueprint/frontend/architecture/001-shell-composition.md
import { AnvilProvider } from '@servicetitan/anvil2';
import { HashBrowserRouter } from '@servicetitan/hash-browser-router';
import { Provider } from '@servicetitan/react-ioc';
// import { LDServiceProvider } from '@servicetitan/launchdarkly-service';
import { StrictMode, FC, ReactNode } from 'react';

import { createApiProviders, LoadingSpinner } from 'org-hub-shared';

import { Shell } from './modules/common/components/Shell';
import { AuthStore } from './modules/common/stores/auth.store';
import { ThemeModeProvider, useThemeMode } from './modules/common/theme/theme-mode';

import './app.scss';

// Feeds the current light/dark mode into anvil2 so the whole tree (incl. portaled overlays) is themed.
const ThemedAnvilProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const { mode } = useThemeMode();
    return <AnvilProvider themeData={{ mode }}>{children}</AnvilProvider>;
};

export const App: FC = () => (
    <HashBrowserRouter>
        <StrictMode>
            <ThemeModeProvider>
                <ThemedAnvilProvider>
                    {/* <LDServiceProvider>

                    </LDServiceProvider> */}
                    {/* Standalone: API clients are same-origin so AuthStore injects UserApi. */}
                    <Provider
                        singletons={[AuthStore, ...createApiProviders()]}
                        loadingFallback={<LoadingSpinner />}
                    >
                        <Shell />
                    </Provider>
                </ThemedAnvilProvider>
            </ThemeModeProvider>
        </StrictMode>
    </HashBrowserRouter>
);
